import { twMerge } from 'tailwind-merge';
import { PropsWithChildren } from 'react';

import { TopNavigation } from 'components';

import { Background } from '../background';

export const PrivateLayout = ({ children }: PropsWithChildren) => (
  <div className="flex min-h-screen w-screen">
    <Background />
    <div className="relative z-10 flex w-full flex-col">
      <div className="sticky top-0 right-0 left-0 z-20 py-2 md:py-4">
        <Wrapper>
          <TopNavigation />
        </Wrapper>
      </div>
      <Wrapper className="flex min-h-0 flex-1 flex-col pt-2">
        {children}
      </Wrapper>
    </div>
  </div>
);

const Wrapper = ({
  children,
  className,
}: PropsWithChildren<{ className?: string }>) => (
  <div
    className={twMerge(
      'w-full px-4 md:px-6 lg:mx-auto lg:max-w-[calc(1328px+(--spacing(28)))] lg:px-14',
      className
    )}
  >
    {children}
  </div>
);
